import { getAxiosClient } from "../../axios-client";
import { PostCheckEmailRequestBody, PostCheckEmailResponse } from "./types";

const axiosClient = getAxiosClient();
export const postCheckEmail = async (body: PostCheckEmailRequestBody) => {
    return await axiosClient.ax.post<PostCheckEmailResponse>(
        "/Users/CheckEmail",
        body
    );
};
